export default __webpack_public_path__ + "static/main_image_mobile-bb20723ef3602dfe8af438ba246f88ac.png";